import apiSlice from "./ApiSlice";

/** The five PCO firms — issuer details + seal & signature for the Employer Certificate. */
export const pcoFirmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPcoFirms: builder.query({
      providesTags: ["pco-firm"],
      query: () => ({
        url: "/pco-firm/get-all",
        method: "GET",
      }),
    }),

    updatePcoFirm: builder.mutation({
      invalidatesTags: ["pco-firm"],
      query: ({ id, body }: { id: string; body: Record<string, string> }) => ({
        url: "/pco-firm/update",
        params: { id },
        method: "PUT",
        body,
      }),
    }),

    // multipart: field "image"; kind "letterhead" uploads the firm's letterhead
    uploadPcoFirmSeal: builder.mutation({
      invalidatesTags: ["pco-firm"],
      query: ({ id, body, kind }: { id: string; body: FormData; kind?: "letterhead" }) => ({
        url: "/pco-firm/upload-seal",
        params: kind ? { id, kind } : { id },
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetPcoFirmsQuery,
  useLazyGetPcoFirmsQuery,
  useUpdatePcoFirmMutation,
  useUploadPcoFirmSealMutation,
} = pcoFirmApi;
